import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPagePaymentMethods = lazy(() => import("./layout/index"));

export const routerPagePaymentMethods: RouterItemType = {
  path: "/billing/paymentmethods",
  authorize: true,
  element: <LayoutPagePaymentMethods />,
};
